import FreelancerUserPaymentMethodEnum from '../../../../Enums/FreelancerUserPaymentMethodEnum';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import WiseTransferMethodEnum from '../../../../Enums/WiseTransferMethodEnum';
import OfficeHelper from '../../../../Helpers/ModelHelpers/OfficeHelper';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import EditFreelancerUserHelper from '../EditFreelancerUserHelper';

export default class PaymentInformationForEurope {
  //#region Validation
  static validityCheckerForPIIBANCodeBankAccountNumber(e, editedItem) {
    if (editedItem.PaymentMethod === FreelancerUserPaymentMethodEnum.Wise) {
      if (
        ValidityHelper.forRequiredTextField(editedItem.PIBankAccountNumber) !== '' &&
        ValidityHelper.forRequiredTextField(editedItem.PIPaypalWiseWesternUnionEmail) !== ''
      ) {
        return 'Either Bank Account Number or Wise Email field have to be filled. ';
      }
      return '';
    }
    if (editedItem.PaymentMethod === FreelancerUserPaymentMethodEnum.BankTransfer) {
      if (
        ValidityHelper.forRequiredTextField(editedItem.PIBankAccountNumber) !== '' &&
        ValidityHelper.forRequiredTextField(editedItem.PIIBANCodeBankAccountNumber) !== ''
      ) {
        return 'Either Bank Account Number or IBan Code / Bank Account Number field have to be filled. ';
      }
      return '';
    }
  }

  static validityCheckerForPIPaypalWiseWesternUnionEmail(e, editedItem) {
    if (editedItem.PaymentMethod === FreelancerUserPaymentMethodEnum.Wise) {
      if (
        ValidityHelper.forRequiredTextField(editedItem.PIBankAccountNumber) !== '' &&
        ValidityHelper.forRequiredTextField(editedItem.PIPaypalWiseWesternUnionEmail) !== '' &&
        ValidityHelper.forRequiredTextField(editedItem.PISwiftIFSCCode) !== ''
      ) {
        return 'Either Bank Account Number or Wise Email field have to be filled. ';
      }
      if (
        ValidityHelper.forRequiredTextField(editedItem.PIBankAccountNumber) !== '' &&
        ValidityHelper.forRequiredTextField(editedItem.PISwiftIFSCCode) !== ''
      ) {
        return ValidityHelper.forEmailRequired(editedItem.PIPaypalWiseWesternUnionEmail);
      }
      return ValidityHelper.forEmailNotRequired(editedItem.PIPaypalWiseWesternUnionEmail);
    }

    return ValidityHelper.forEmailRequired(editedItem.PIPaypalWiseWesternUnionEmail);
  }

  static validityCheckerForPISwiftIFSCCode(e, editedItem) {
    if (editedItem.PaymentMethod === FreelancerUserPaymentMethodEnum.BankTransfer)
      return ValidityHelper.forMinimumLengthField(e, 6);

    if (editedItem.PaymentMethod === FreelancerUserPaymentMethodEnum.Wise && editedItem.PIPaypalWiseWesternUnionEmail)
      return '';

    return ValidityHelper.forRequiredTextField(editedItem.PISwiftIFSCCode);
  }
  //#endregion

  static returnDescriptionTab() {
    return {
      label: 'Europe Payment Information',
      hide: (item) => EditFreelancerUserHelper.isBillingDetailHidden(item, OfficeHelper.GetEUOffices()),
      fields: [
        {
          fieldName: (item) => item.PaymentCurrencyId,
          label: 'Payment Currency',
          className: 'col-6',
          type: InputTypesEnum.CurrencySelect,
          selectvalues: [45],
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
        {
          fieldName: 'PaymentMethod',
          label: 'Payment Method',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: EditFreelancerUserHelper.getPaymentMethodSelectOptions,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'PIAccountHolderName',
          label: 'Account Holder Name',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: ValidityHelper.forRequiredTextField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer),
        },
        {
          fieldName: 'PIBankAccountNumber',
          label: (item) =>
            item.PaymentMethod === FreelancerUserPaymentMethodEnum.BankTransfer
              ? 'Bank Account Number'
              : 'Bank Account Number (Wise)',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: PaymentInformationForEurope.validityCheckerForPIIBANCodeBankAccountNumber,
          disabled: (item) =>
            item.PaymentMethod === FreelancerUserPaymentMethodEnum.Wise && item.PIPaypalWiseWesternUnionEmail,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, [
              FreelancerUserPaymentMethodEnum.BankTransfer,
              FreelancerUserPaymentMethodEnum.Wise,
            ]),
        },
        {
          fieldName: 'PISwiftIFSCCode',
          label: (item) =>
            item.PaymentMethod === FreelancerUserPaymentMethodEnum.BankTransfer ? 'Swift Code' : 'Wise Swift Code',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: PaymentInformationForEurope.validityCheckerForPISwiftIFSCCode,
          disabled: (item) =>
            item.PaymentMethod === FreelancerUserPaymentMethodEnum.Wise && item.PIPaypalWiseWesternUnionEmail,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, [
              FreelancerUserPaymentMethodEnum.BankTransfer,
              FreelancerUserPaymentMethodEnum.Wise,
            ]),
        },
        {
          fieldName: 'PIIBANCodeBankAccountNumber',
          label: 'IBAN Code',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: PaymentInformationForEurope.validityCheckerForPIIBANCodeBankAccountNumber,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.BankTransfer),
        },
        {
          fieldName: 'PIPaypalWiseWesternUnionEmail',
          label: (item) =>
            item.PaymentMethod === FreelancerUserPaymentMethodEnum.PayPal ? 'PayPal Email' : 'Wise Email',
          className: 'col-6',
          type: InputTypesEnum.Text,
          validityChecker: PaymentInformationForEurope.validityCheckerForPIPaypalWiseWesternUnionEmail,
          disabled: (item) =>
            item.PaymentMethod === FreelancerUserPaymentMethodEnum.Wise &&
            (item.PIBankAccountNumber || item.PISwiftIFSCCode),
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, [
              FreelancerUserPaymentMethodEnum.PayPal,
              FreelancerUserPaymentMethodEnum.Wise,
            ]),
        },
        {
          fieldName: 'PIWiseTransferMethod',
          label: 'Wise Transfer Method',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: EditFreelancerUserHelper.getSelectOptionsForWiseTransferMethod(),
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.Wise),
        },
        {
          fieldName: 'PIWiseTargetCurrencyId',
          label: 'Wise Target Currency',
          className: 'col-6',
          type: InputTypesEnum.CurrencySelect,
          validityChecker: ValidityHelper.forRequiredSelectField,
          hide: (item) =>
            EditFreelancerUserHelper.isBillingDetailFieldHidden(item, FreelancerUserPaymentMethodEnum.Wise) ||
            item.PIWiseTransferMethod !== WiseTransferMethodEnum.TargetCurrency,
        },
      ],
    };
  }
}
